module.exports = __webpack_public_path__ + "img/banner-princiapal.2a2eb6b3.png";